import { Outlet } from "react-router-dom";
import { CX } from "../Tags/ConteudoX";
import { Footer } from "./Footer";
import { Header } from "./Header";
// fechar sidebar
export const Layout = () => {
  const nav = [
    { texto: "Home", rota: window.location.pathname === "/" ? "#" : "/" },
    { texto: "Serviços", rota: "#servicos" },
    { texto: "Dúvidas", rota: "#perguntas" },
  ];

  return (
    <CX tipo="div" className={`home-claro`}>
      <Header imagem="/projeto/logo.webp" navbar={nav} />
      <Outlet />
      <Footer />
    </CX>
  );
};
